import { Route } from "react-router-dom";
import { SimpleErrorBoundary } from "~/components";
import { lazyNamedPage } from "~/utils/routing/lazyPage";
import {
  ServiceRequestDetailsPageLoader,
  ServiceRequestDetailsPageAction,
} from "./ServiceRequestDetailsPage/loaders";
import {
  ServiceRequestTablePageLoader,
  ServiceRequestTablePageAction,
} from "./ServiceRequestTablePage/loaders";
import { ROUTES } from "~/utils";

const ServiceRequestTablePage = lazyNamedPage("ServiceRequestTablePage", () =>
  import(
    /* webpackChunkName: "service-request" */
    "./ServiceRequestTablePage/ServiceRequestTablePage"
  ),
);
const ServiceRequestDetailsPage = lazyNamedPage("ServiceRequestDetailsPage", () =>
  import(
    /* webpackChunkName: "service-request" */
    "./ServiceRequestDetailsPage/ServiceRequestDetailsPage"
  ),
);

export const ServiceRequestRoutes = () => {
  return (
    <>
      <Route
        path={ROUTES.serviceRequest}
        loader={ServiceRequestTablePageLoader}
        action={ServiceRequestTablePageAction}
        ErrorBoundary={() => SimpleErrorBoundary()}
        element={<ServiceRequestTablePage />}
      />
      <Route
        path={ROUTES.serviceRequestDetails}
        loader={ServiceRequestDetailsPageLoader}
        action={ServiceRequestDetailsPageAction}
        ErrorBoundary={() => SimpleErrorBoundary()}
        element={<ServiceRequestDetailsPage />}
      />
    </>
  );
};
